import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import SearchPaging from "./../factories/search-paging";
import { TicketTypeCategoriesConstants } from "./constants/ticket-type-categories-constants"

// bao migrate - module not found: import Synoset from "modules/synoset-module";
class TicketTypeViewModel extends SearchPaging {

    TicketTypeId = ko.observable("");
    TicketTypeCategoryId = ko.observable();
    TicketTypeColors = ko.observableArray();
    Color = ko.observable();
    Type = ko.observable("");
    Key = ko.observable("");
    CategoryName = ko.observable("");

    TicketTypeIconFilename = ko.observable();
    IconUploadEnabled = ko.observable(true);

    UploadIcon() {
        // dummy
        return null;
    };

    constructor(tabPage) {
        super(tabPage);
    }

    CompleteCheck() {
        var isComplete = true;

        if (Bao.Utils.String.IsNullOrEmpty(this.Type())
            || Bao.Utils.String.IsNullOrEmpty(this.CategoryName())
            || Bao.Utils.String.IsNullOrEmpty(this.Key()))
        {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return false;
        }
        
        return this.UploadIcon().then(() => { return true; });
    };

    init() {
        return super.init().then(() => { return this.GetTicketTypeColors(); })
    }

    ShowEnableHolidayEntitlement = ko.computed(() => {
        return this.IsHolidayRequestCategory();
    });

    // Controls whether the checkbox for the "Approval Workflow" should be visible or hidden
    ShowApprovalWorkflow = ko.computed(() => {
        return this.IsHolidayRequestCategory();
    });

    IsHolidayRequestCategory(): boolean {
        if (this.TicketTypeCategoryId() === TicketTypeCategoriesConstants.HOLIDAY_REQUEST 
            || this.TicketTypeCategoryId() === TicketTypeCategoriesConstants.ABSENCE_REQUEST) {
            return true;
        }
        return false;
    }

    GetTicketTypeColors() {
        return Bao.post("TicketType/GetTicketTypeColors", (result) => { this.TicketTypeColors(result.TicketTypeColors); });
    };

    PrimaryKey = "TicketTypeId";
    RefreshUrl = "TicketType/Get";
    SaveUrl = "TicketType/Save";
    DeleteUrl = "TicketType/Delete";
    IsInUseUrl = "TicketType/IsInUse";

    PermissionForward = "TicketTypeMoveForwardSearch";
    PermissionBackward = "TicketTypeMoveBackwardSearch";
    PermissionSave = "TicketTypeSave";
    PermissionRefresh = "TicketTypeRefresh";
    PermissionDelete = "TicketTypeDelete";
}

export default TicketTypeViewModel;